/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Dialog, DialogContent, DialogTitle, IconButton, Theme, WithStyles, withStyles } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import CloseIcon from "@material-ui/icons/Close";
import * as React from "react";

import { ProductHelper } from "../../helper/Product.helper";
import { Benchmark } from "../../types/Benchmark";
import { Customer } from "../../types/Customer";
import { NotificationItem } from "../../types/NotificationItem";
import { ProductName, ProductVariantName } from "../../types/Products";
import { Quotation } from "../../types/Quotation";
import CalculatorPopinForm from "./CalculatorPopinForm";
import { User } from "../../models/User.model";

type CalculatorPopinProps = WithStyles<typeof styles> & {
    dico: any;
    open: boolean;
    user: User;
    productName: ProductName;
    productVariantName: ProductVariantName;
    onClick();
};

type CalculatorPopinState = {
    quotation: Quotation;
    customer: Customer;
    notification: NotificationItem;
};

class CalculatorPopin extends React.Component<CalculatorPopinProps, CalculatorPopinState> {
    public render() {
        const { classes, dico, open, onClick, theme } = this.props;

        return (
            <Dialog open={open} onClose={onClick} maxWidth={"md"} aria-labelledby="Calculator" scroll="body">
                <DialogContent>
                    <DialogTitle className={classes.header}>
                        {dico.cover.title}
                        <IconButton onClick={onClick}>
                            <CloseIcon nativeColor={theme.palette.primary.main} />
                        </IconButton>
                    </DialogTitle>
                    <CalculatorPopinForm
                        user={this.props.user}
                        productName={this.props.productName}
                        productVariantName={this.props.productVariantName}
                    />
                </DialogContent>
            </Dialog>
        );
    }
}

export const styles = ({ spacing, palette }: Theme) =>
    createStyles({
        header: {
            padding: 0,
            "& h2": {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            },
        },
    });

export default withStyles(styles, { withTheme: true })(CalculatorPopin);



// WEBPACK FOOTER //
// ./src/components/Calculator/CalculatorPopin.tsx